import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import {
  IAllProcurementRequirements,
  IProcurementRequirementItems,
} from 'types/lot/procurement-requirement-items'
import { IPaginationQueryInfo } from 'types/pagination'

type ProcurementRequirements = IPaginationQueryInfo & { lotId: string }

export const procurementRequirementApi = createApi({
  reducerPath: 'procurementRequirement',
  tagTypes: ['AllProcurementItems'],
  baseQuery,
  endpoints: (builder) => ({
    procurementRequirements: builder.query<
      IProcurementRequirementItems,
      ProcurementRequirements
    >({
      query: ({ page, size, lotId }) => {
        const params = new URLSearchParams()

        if (size) {
          params.set('size', String(size))
        }
        if (page) {
          params.set('page', String(page))
        }

        if (lotId && lotId.length > 0) {
          params.set('lotId', lotId)
        }

        return {
          url: '/procurements/search',
          method: 'get',
          params,
        }
      },
    }),
    allProcurementRequirements: builder.query<
      IAllProcurementRequirements,
      { lotId: string }
    >({
      query: ({ lotId }) => {
        const params = new URLSearchParams()

        if (lotId && lotId.length > 0) {
          params.set('lotId', lotId)
        }

        return {
          url: '/procurement-requirements',
          method: 'get',
          params,
        }
      },
      providesTags: ['AllProcurementItems'],
    }),
  }),
})

export const {
  useProcurementRequirementsQuery,
  useAllProcurementRequirementsQuery,
} = procurementRequirementApi
